/*-----------------------------------------------------------------
- Footer
-----------------------------------------------------------------*/
export default {
    title      : 'یسناشاپ',
    login      : 'ورود',
    register   : 'ثبت‌نام',
    search     : 'نام محصول مورد نظر خود را وارد کنید',
    separator  : ' / ',
    auth_button: 'ورود / ثبت‌نام',
    categories : 'دسته بندی کالا ها',
};
